import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms'
import { ValidationsService } from '../../services/common/validations.service';
import { environment } from '../../../environments/environment';

declare var $: any;
@Component({
  selector: 'app-my-team',
  templateUrl: './my-team.component.html',
  styleUrls: ['./my-team.component.scss']
})
export class MyTeamComponent implements OnInit {

  // @ViewChild('editTeamMemberModalRef', { static: true }) editTeamMemberModal: ElementRef;

  isLoading = true;

  optionForm: FormGroup;

  getTeamPostData = {
    role: '',
    offset: '',
    search: ''
  };
  teamList;
  teamListForCsvDownload;

  // Add Team Member
  teamMemberForm: FormGroup;
  submitted = false;
  emailsList: string[] = [];

  // Delete Team Member
  actionPostData = {
    counselor_id: Number,
    action: Number
  };

  // Edit Team Member
  editMemberForm: FormGroup;
  editFormSubmitted = false;

  isLargeImage = false;
  isImageUploaded = true;
  uploadedImageName = '';
  displayImageUrl;

  // Reset Password
  isResetLinkSent = false;
  resetButtonText = 'Reset Password';
  resetButtonIndex;

  // Pagination
  noOfPages;

  // Filter
  filters;
  status = [];

  constructor(private formBuilder: FormBuilder, private validationService: ValidationsService, private dashboardService: DashboardService) { }

  ngOnInit() {
    this.filters = [
      { label: 'Active', value: 1 },
      { label: 'Inactive', value: 2 }
    ];

    this.optionForm = this.formBuilder.group({
      role: ['']
    });

    this.getTeamList();

    this.optionForm.get('role').valueChanges.subscribe(optedValue => {
      this.getTeamPostData.role = optedValue;
      this.getTeamPostData.offset = '';

      this.getTeamList();
    });

    // Add Team Member
    this.teamMemberForm = this.formBuilder.group({
      teamMembers: new FormArray([])
    });

    this.addMemberField();

    // Edit Team Member Form
    this.editMemberForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: [''],
      phone: ['', [Validators.required, Validators.maxLength(10), Validators.pattern('[1-9][0-9]{9}')]],
      role: [''],
      status: [''],
      image: [''],
      counselor_id: ['']
    });
  }

  // getters
  get name() { return this.editMemberForm.get('name'); }
  get phone() { return this.editMemberForm.get('phone'); }
  get image() { return this.editMemberForm.get('image'); }
  get counselorId() { return this.editMemberForm.get('counselor_id'); }

  // getter for Add Team Member Form Array (teamMembers)
  get teamMemberFormField() { return this.teamMemberForm.get('teamMembers') as FormArray; }

  setFiltersAndGetList(event) {
    if (this.status.length == 2 || this.status.length == 0) {
      if (this.getTeamPostData.hasOwnProperty('status')) {
        delete this.getTeamPostData['status'];
      }
      this.getTeamList();
    }
    else {
      this.getTeamPostData['status'] = event.value[0];
      this.getTeamList();
    }
  }

  getTeamList() {
    if (this.getTeamPostData.search != '') {
      this.getTeamPostData.offset = '';
    }

    this.dashboardService.getTeamList(this.getTeamPostData).subscribe(response => {
      this.isLoading = false;

      if (response.data != null) {
        this.teamList = response.data.counselorDetails;
        this.noOfPages = response.data.count;

        (this.teamList).forEach(element => {
          if (element.image != null) {
            element.image = environment.counsellor_photo_baseUrl + element.counselor_id + '/' + element.image;
          }
        });
      }
      else {
        this.teamList = null;
      }
    });
  }

  // Download CSV
  downloadCsv() {
    const fileName = 'My_Team';

    this.dashboardService.getTeamListForCsvDownload(this.getTeamPostData).subscribe(response => {
      if (response.data != null) {
        this.teamListForCsvDownload = response.data.counselorDetails;
        this.dashboardService.exportToCsvService(fileName, this.teamListForCsvDownload);
      }
      else {
        this.teamListForCsvDownload = null;
      }
    });
  }

  // add form
  addMemberField() {
    this.teamMemberFormField.push(
      this.formBuilder.group({
        emailId: ['', [Validators.required, this.validationService.validateEmail]]
      })
    );
    this.submitted = false;
  }

  removeMemberField(formIndex) {
    this.teamMemberFormField.removeAt(formIndex);
    // this.submitted = false;
  }

  addTeamMembersFormSubmit() {
    if (this.teamMemberFormField.length == 0) {
      $('#addTeamMember').modal('hide');
      return;
    }

    this.submitted = true;

    if (this.teamMemberForm.invalid) {
      return;
    }

    (this.teamMemberForm.get('teamMembers').value).forEach(element => {
      this.emailsList.push(element.emailId);
    });

    const postData = {
      emails: this.emailsList
    };

    this.dashboardService.sendInvitations(postData).subscribe(response => {
      this.teamMemberForm.reset();
      this.submitted = false;
      this.emailsList = [];
      while (this.teamMemberFormField.length != 0) {
        this.teamMemberFormField.removeAt(0);
      }
      this.addMemberField();
    });

    $('#addTeamMember').modal('hide');
  }

  // delete/activate/deactivate member form step-1 (Set remove params)
  setActionParameters(counselorId, action) {
    this.actionPostData.counselor_id = counselorId;
    this.actionPostData.action = action;

    if (action == 1 || action == 2) {
      this.submitMemberAction();
    }
  }

  // delete/activate/deactivate member form step-2
  submitMemberAction() {
    this.dashboardService.teamMemberAction(this.actionPostData).subscribe(response => {
      this.getTeamList();
    });
  }

  // phone no.
  onlyNumericInput(event) {
    return this.validationService.isNumericInput(event);
  }

  // Edit Team Members - Set Params
  setEditTeamMemberParameters(member) {
    this.editFormSubmitted = false;

    this.editMemberForm.patchValue({
      name: member.name,
      email: member.email,
      phone: member.phone,
      image: member.image,
      role: member.role,
      status: member.status,
      counselor_id: member.counselor_id
    });
  }

  //
  uploadImage(event) {
    if (event.target.files[0].size > 500000) {
      this.isLargeImage = true;
    }
    else {
      this.isLargeImage = false;

      const uploadData = new FormData();
      uploadData.append('image', event.target.files[0]);
      uploadData.append('counselor_id', this.counselorId.value);

      this.dashboardService.uploadMemberImage(uploadData).subscribe(data => {
        this.uploadedImageName = data.name;

        this.displayImageUrl = environment.counsellor_photo_baseUrl + this.counselorId.value + '/' + this.uploadedImageName;

        this.editMemberForm.patchValue({
          image: this.displayImageUrl
        });
      });
    }
  }

  // Edit Team Members - Form Submit
  editMemberFormSubmit() {
    this.editFormSubmitted = true;

    if (this.editMemberForm.invalid) {
      return;
    }

    this.editMemberForm.patchValue({
      image: this.uploadedImageName
    });

    this.dashboardService.updateMember(this.editMemberForm.value).subscribe(data => {
      this.getTeamList();
    });
    // console.log(this.editTeamMemberModal);
    // this.editTeamMemberModal.nativeElement.modal('hide');
    $('#editTeamMember').modal('hide');
  }

  // reset password
  resetMemberPassword(memberId, index) {
    this.resetButtonIndex = index;

    const postData = {
      counselor_id: memberId
    };

    this.dashboardService.sendResetPasswordLink(postData).subscribe(response => {
      this.isResetLinkSent = true;
      this.resetButtonText = 'Link Sent';

      this.updateResetBtnText();
      // this.getTeamList();
    });
  }

  updateResetBtnText() {
    setTimeout(() => {
      this.resetButtonText = 'Reset Password';
    }, 5000);
  }

  paginate(event) {
    this.getTeamPostData.offset = (event.first);
    this.getTeamList();
  }

}
